import axios from "axios";
import Course from "./Course.class";
import AdminService from "@/services/admin.service.js";


/**
 * @classdesc Liste des courses d'un module
 * @kind class
 * @export
 * @prop {int} id_module - Id du module
 * @prop {array} list - Liste des courses
 * @class List_Courses
 */
export default class List_Courses {
    id_module;
    list = [];

    /**
     *  Initialise la liste des courses
     *
     * @constructs
     * @memberof List_Courses
     */
    constructor(id) {
        this.id_module = id;
    }

    /**
     * Appel API pour charger la liste
     *
     * @return {boolean} success
     * @async
     * @memberof List_Courses
     */
    async fetch(filter = "", mode = "") {
        let res = await axios.get("/public/courses/get.php?filter=" + filter + "&mode=" + mode + "&sort=date&id_module=" + this.id_module);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            this.set(res.data);
            return await true;
        }
    }


    async fetch_all(mode = "", has_preinscriptions = false) {
        let res = await AdminService.getCourses(this.id_module, mode, has_preinscriptions);
        if (res) {
            this.set(res);
        }
    }

    /**
     * Créer la liste des courses du module
     *
     * @param {array} data
     * @memberof List_Courses
     */
    set(data) {

        for (let i = 0; i < data.length; i++) {
            let course = new Course();
            course.set(data[i]);
            this.list.push(course);
        }
    }



    /* 
        Retire les courses complètes
    */
    remove_full(admin_ins, vip_ins, lien_groupe = null) {
        let all_courses = JSON.parse(JSON.stringify(this));
        if (admin_ins) {
            return;
        }
        for (let i = this.list.length - 1; i >= 0; i--) {
            let omit = false;
            if (vip_ins && vip_ins.limit_acces_parcours == "0") { // Si le VIP a accès à tous les parcours
                continue;
            }
            if (vip_ins && vip_ins.limit_acces_parcours == "1") { // Si le VIP a accès à certains parcours
                for (let j = 0; j < vip_ins.filter_parcours.length; j++) {
                    if (vip_ins.filter_parcours[j].id == this.list[i].id) { // Si le parcours est dans la liste des parcours autorisé du VIP
                        omit = true; // On ne retire pas le parcours
                    }
                }
            }
            if (lien_groupe && !lien_groupe.limit_acces_parcours) { // Si le lien groupe a accès à tous les parcours
                omit = true;
            }
            if (lien_groupe && lien_groupe.limit_acces_parcours) { // Si le lien groupe a accès à certains parcours
                const ids = lien_groupe.filter_parcours ? lien_groupe.filter_parcours.split(',').map(id => id.trim()) : [];
                if (ids.includes(String(this.list[i].id))) {
                    omit = true;
                }
            }
            if (this.list[i].is_complet(all_courses) && !omit) {
                this.list.splice(i, 1);
            }
        }
    }

    remove_by_id(id) {
        for (let i = this.list.length - 1; i >= 0; i--) {
            if (this.list[i].id == id) {
                this.list.splice(i, 1);
                return;
            }
        }
    }

    remove_course_equipe() {
        for (let i = this.list.length - 1; i >= 0; i--) {
            if (this.list[i].type == 'duo' || this.list[i].type == 'relais' || this.list[i].type == 'equipe') {
                this.list.splice(i, 1);
            }
        }
    }

    toggle_course_selection(index, inscription_plusieurs) {
        let course = this.list[index];
        if (course.selected) {
            return this.add_course_to_selection(course, inscription_plusieurs);
        }
        else {
            return this.remove_course_from_selection(course);
        }
    }

    get_selected() {
        return this.list.filter(course => course.selected);
    }


    /**
     * Ajoute une course à la selection
     *
     * @param {Course} course
     * @param {boolean} inscriptions_plusieurs
     * @return {*} 
     * @kind function
     * @memberof List_Courses
     */
    add_course_to_selection(course, inscription_plusieurs) {
        let result = { state: true, errors: [] };
        // Si le module n'autorise pas plusieurs courses

        if (this.count_selected() > 1 && !inscription_plusieurs) {
            for (let i = 0; i < this.list.length; i++) {
                if (this.list[i].selected && this.list[i].id != course.id) {
                    this.list[i].selected = false;
                }
            }
        }
        // Si la course est dans un créneau, vérifie qu'elle est compatible avec la sélection en cours
        if (course.metadatas.creneau_course) {
            let overlap = this.verify_if_course_overlap(course);
            if (overlap) {
                course.selected = false;
                result.state = false;
                result.errors.push("Vous ne pouvez pas participer à la course '" + course.nom + "' car vous participez déjà à la course '" + overlap.nom + "'");
                return result;
            }
        }
        // Si pas d'erreur, ajoute la course
        return result;
    }

    /**
     * Supprime une course de la sélection
     *
     * @param {Course} course
     * @return {*} 
     * @memberof List_Courses
     */
    remove_course_from_selection(course) {
        let result = { state: true, errors: [] };
        course.selected = false;
        return result;
    }

    add_course_from_pack(pack) {
        for (let i = 0; i < pack.list_liaisons.length; i++) {
            let course = this.get_course_by_id(pack.list_liaisons[i].id_course);
            course.selected = true;
        }
    }
    remove_course_from_pack(pack) {
        for (let i = 0; i < pack.list_liaisons.length; i++) {
            let course = this.get_course_by_id(pack.list_liaisons[i].id_course);
            course.selected = false;
        }
    }


    /**
     * Vérifie si la course n'est pas sur le même créneau qu'une autre course sélectionnée
     *
     * @param {*} selection
     * @return {*} 
     * @memberof List_Courses
     */
    verify_if_course_overlap(course) {
        for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].id != course.id
                && this.list[i].metadatas.creneau_course
                && this.list[i].metadatas.creneau_course == course.metadatas.creneau_course
                && this.list[i].selected) {
                return this.list[i];
            }
        }
        return false;
    }

    get_course_by_id(id) {
        for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].id == id) {
                return this.list[i];
            }
        }
        return false;
    }

    /**
  * Retourne le nombre de course sélectionnée
  *
  * @return {int} count_selected  
  * @memberof List_Courses
  */
    count_selected() {
        return this.list.filter(course => course.selected).length;
    }


    update_cart(packs, coureur, vip_ins = null, inscription = null, lien_groupe = null) {
        let cart = { nb_articles: 0, prix: 0 };
        for (let i = 0; i < this.list.length; i++) {
            let item_cart = this.list[i].update_cart(this.list, packs, coureur, vip_ins, inscription, lien_groupe);
            cart.nb_articles += parseInt(item_cart.nb_articles);
            cart.prix += parseFloat(item_cart.prix);
        }
        this.cart = cart;
        return this.cart;
    }



    get_list_choix() {
        let list_choix = this.list.map(item => {
            let choix = {};
            choix.id = item.id;
            choix.value = item.nom;
            choix.selected = false;
            return choix;
        });
        return list_choix;
    }

    async update_config() {
        let res = await AdminService.updateCoursesConfig(this);
        return res;
    }

    /* ------------------------------- */

    /**
     * Initializes the list of courses from the main store if it is not already initialized.
     * 
     * @param {Array} courses - An array of course data to initialize the list with.
     */
    initialize_from_mainstore(courses) {
        if (this.has_courses()) {
            return;
        }
        for (let i = 0; i < courses.length; i++) {
            let course = new Course();
            course.set(courses[i]);
            this.list.push(course);
        }
    }

    /**
     * Checks if there are any courses in the list.
     *
     * @returns {boolean} True if the list contains one or more courses, false otherwise.
     */
    has_courses() {
        return this.list.length > 0
    }

    /**
     * Retrieves a list of selectable courses based on the provided criteria.
     *
     * @param {string} statut_ouverture_module - The status of the module's opening.
     * @param {boolean} admin_view - Indicates if the admin view is enabled.
     * @param {boolean} admin_ins - Indicates if the admin is in the session.
     * @param {boolean} vip_ins - Indicates if the VIP is in the session.
     * @returns {Array} An array of selectable courses.
     */
    get_courses_selectionnables(statut_ouverture_module, admin_view, admin_ins, vip_ins, module_complet, lien_groupe = null) {
        let courses = [];

        for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].is_selectionnable(statut_ouverture_module, admin_view, admin_ins, vip_ins, this, module_complet, lien_groupe)) {
                courses.push(this.list[i]);
            }
        }
        return courses;
    }

    /**
     * Checks if there are any selected courses that have vagues but no vague is selected.
     *
     * @returns {boolean} - Returns true if there is at least one selected course with vagues and no vague is selected, otherwise false.
     */
    check_missing_vagues_selection() {
        for (let i = 0; i < this.list.length; i++) {
            const course = this.list[i];
            if (course.selected && course.has_vagues() && course.vague_selected == 0 && !course.hide_vagues_from_user()) {
                return true;
            }
        }
        return false;
    }

    /**
     * Retrieves the IDs of the selected items from the list.
     *
     * @returns {Array<number>} An array of IDs of the selected items.
     */
    get_selected_ids() {
        let selected_ids = [];
        for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].selected) {
                selected_ids.push(this.list[i].id);
            }
        }
        return selected_ids;
    }

    /**
     * Retrieves the list of selected courses.
     *
     * @returns {Array} An array of courses that are selected.
     */
    get_selected_courses() {
        return this.list.filter(course => course.selected);
    }

    requires_vague_justificatif() {
        for (let i = 0; i < this.list.length; i++) {
            const course = this.list[i];
            if (!course.selected) continue;
            const vague = course.get_selected_vague();
            if (vague?.requires_justificatif()) {
                return true;
            }
        }
        return false;
    }

    get_vagues_requiring_justificatif() {
        let vagues = [];
        for (let i = 0; i < this.list.length; i++) {
            const course = this.list[i];
            if (!course.selected) continue;
            const vague = course.get_selected_vague();
            if (vague?.requires_justificatif()) {
                vagues.push(vague.nom);
            }
        }
        return vagues;
    }

    getSimplifiedData() {
        if (this.cart?.nb_articles == 0) return null;
        let infos = {};
        infos.prix = this?.cart?.prix;
        infos.list = [];
        for (let i = 0; i < this.list.length; i++) {
            const course = this.list[i];
            let course_infos = course.getSimplifiedData();
            if (course_infos) {
                infos.list.push(course_infos);
            }
        }
        return infos;
    }

    getCheckAvailabilitiesData() {
        let data = {};
        data.list = [];
        for (let i = 0; i < this.list.length; i++) {
            const course = this.list[i];
            let course_infos = course.getCheckAvailabilitiesData();
            if (course_infos) data.list.push(course_infos);
        }
        return data;
    }
}
